




































import { defineComponent, PropType, ref } from 'vue';
import PermissionsDialog from '@/components/PermissionsDialog.vue';

export default defineComponent({
  components: {
    PermissionsDialog,
  },

  props: {
    workspace: {
      type: String as PropType<string>,
      required: true,
    },
  },

  setup() {
    const actionsMenu = ref(false);

    return {
      actionsMenu,
    };
  },
});
